/**
 * @author Mevan Nirosh
 * @version 1.0
 * @since 04/25/2023
 */

const idToken = JSON.parse(localStorage.getItem("DecryptedIdToken"))

const getAccessToken = () => {
  const accessToken = JSON.parse(localStorage.getItem("accessToken"))
  return accessToken ? accessToken : ""
}
const getRefreshToken = () => {
  const refreshToken = JSON.parse(localStorage.getItem("refreshToken"))
  return refreshToken ? refreshToken : ""
}
const setAccessToken = (accessToken) => {
  localStorage.setItem("accessToken", JSON.stringify(accessToken))
}
const getUsername = () => {
  const { sub } = JSON.parse(window.localStorage.getItem("DecryptedIdToken"))
  return sub ? sub : ""
}

// const getSessionTimout = () => {
//   const time = parseInt(idToken?.session_timeout?.replace("min", ""))
//   console.log("storage", idToken?.session_timeout?.replace("min", ""))
//   const inSeconds = time * 60
//   return inSeconds ? inSeconds : 1200
// }

const getSessionTimeout = async () => {
  // Wrap the code that retrieves idToken in a Promise
  const getIdToken = new Promise((resolve, reject) => {
    const idTokenData = localStorage.getItem("DecryptedIdToken")
    if (idTokenData) {
      resolve(JSON.parse(idTokenData))
    } else {
      reject("Id token data not found in localStorage")
    }
  })

  try {
    // Wait for idToken data to be retrieved
    const idToken = await getIdToken

    // Now you can safely access idToken and perform your logic
    const time = parseInt(idToken?.session_timeout?.replace("min", ""))
    const inSeconds = time * 60
    return inSeconds ? inSeconds : 1200
  } catch (error) {
    // Handle errors, such as if idToken data is not found
    console.error("Error retrieving idToken data:", error)
    // You might want to return a default timeout value or throw the error
    return 1200
  }
}

const getUserData = () => {
  const {
    user_role,
    sub,
    first_name,
    last_name,
    display_name,
    reference_no,
    prim_email,
    sec_email,
    prim_contact,
    sec_contact,
    prim_address,
    sec_address,
  } = JSON.parse(window.localStorage.getItem("DecryptedIdToken"))

  const userData = {
    userRole: user_role,
    username: sub,
    firstName: first_name,
    lastName: last_name,
    displayName: display_name,
    referenceNo: reference_no,
    primEmail: prim_email,
    secEmail: sec_email,
    primContact: prim_contact,
    secContact: sec_contact,
    primAddress: prim_address,
    secAddress: sec_address,
  }
  return userData ? userData : ""
}

const StorageService = {
  getAccessToken,
  getRefreshToken,
  setAccessToken,
  getUsername,
  getSessionTimeout,
  getUserData,
}
export default StorageService
